import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";

class TransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            login_merchant:''
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("transaction_reports")===false){
            this.unauthorize_access();
        }
        this.setState({
            reportPermissionsArray:reportPermissions,
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        console.log(arrayCode);
        if(decoded.userType==='External')
        {
        axios.post(config.get('API_URL')+'/filters/filter-dmart-login/',{
            object_type: decoded.object_type,
            object_code: arrayCode
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

            }).then(response => {
                if(response.data===null || response.data==='null' || response.data==='' )
                {

                }else{
                    this.setState({
                        login_merchant: response.data.merchant_code
                    })
                }


            });
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    render() {
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <div className="header">
                                                    <h4 className="title">Transaction</h4>
                                                    <p className="category"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="content">

                                    <div className="row">
                                        {this.state.reportPermissionsArray.includes("live_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/live-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Live Transactions Report</h5>
                                                           {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null }
                                        {this.state.reportPermissionsArray.includes("daily_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/daily-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Daily Transactions Report</h5>
                                                           {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null }
                                        {this.state.reportPermissionsArray.includes("dcc_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/dcc-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>DCC Transactions Report
                                                            </h5>
                                                           {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                         : null }

                                        {this.state.reportPermissionsArray.includes("google_pay_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/google-pay-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Google Pay Transactions Report</h5>
                                                           {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null }


                                    </div>
                                    {/*<div className="col-lg-3 col-xs-6">*/}
                                    {/*    <div className="card">*/}
                                    {/*        <div className="content text-center">*/}
                                    {/*            <div className="report-thumbs-ico">*/}
                                    {/*                <div className="folder"></div>*/}
                                    {/*                <h5>Rupay Transactions Report</h5>*/}
                                    {/*                <p><b>Last updated :</b> 2020-03-28 00:00:00</p>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="row">
                                        {this.state.reportPermissionsArray.includes("phonePe_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/PhonePe-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>PhonePe Transactions Report</h5>
                                                           {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> :null }
                                            {this.state.reportPermissionsArray.includes("upi_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/upi-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>UPI Transactions Report
                                                            </h5>
                                                            {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> :null }
                                            {this.state.reportPermissionsArray.includes("emi_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/emi-transaction-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>EMI Transactions Report</h5>
                                                            {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> :null }
                                            {this.state.reportPermissionsArray.includes("contactless_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/contact-less-transaction-report">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>ContactLess Payment Transactions Report
                                                            </h5>
                                                           {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null}
                                    </div>
                                    <div className="row">
                                        {this.state.reportPermissionsArray.includes("cashback_transaction")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/transaction-cash-back-report">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Transactions Cashback Report
                                                            </h5>
                                                            {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null }
                                        {this.state.reportPermissionsArray.includes("acquirer_summary_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className="" to="/admin/acquirer-summary-report">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Acquirer Summary Report</h5>
                                                                {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }
                                        {this.state.reportPermissionsArray.includes("issuer_summary_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className="" to="/admin/issuer-summary-report">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Issuer Summary Report</h5>
                                                                {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }

                                        {this.state.reportPermissionsArray.includes("txn_summary_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className="" to="/admin/txn-summary">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Txn Summary Report</h5>
                                                                {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }

                                            {this.state.reportPermissionsArray.includes("genie_daily_transaction")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className="" to="/admin/genie-transaction-report/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>G.E.N.I.E. Transactions Report</h5>
                                                            {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }

                                            {this.state.reportPermissionsArray.includes("axis_aggregator_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className="" to="/admin/axis-aggregator-report/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Axis aggregator Report</h5>
                                                            {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div> : null }

                                            {this.state.reportPermissionsArray.includes("binmanager_summary_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className="" to="/admin/bin-manager-summary-report/">
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Transaction failure - BIN Issues - Summary Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                            {this.state.reportPermissionsArray.includes("utid_wise_summary_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className="" to="/admin/utid-wise-summary-report">
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Utid Wise Summary Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> : null}

                                            {this.state.reportPermissionsArray.includes("upi_vpa_handler_report") === true || this.state.login_merchant==='MAVE0001'?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className=""  to={{
                                                                                    pathname: "/admin/upi-vpa-handler-report",
                                                                                    state: this.state.login_merchant
                                                                                  }}>
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>UPI VPA handler report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            : null}
                                            {this.state.reportPermissionsArray.includes("reliance_grab_upi_report") === true || this.state.login_merchant==='RELI0001'?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className=""  to={{
                                                                                    pathname: "/admin/reliance-grab-upi-transaction-report",
                                                                                    state: this.state.login_merchant
                                                                                  }}>
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Reliance Grab UPI Transaction Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            : null}
                                            {this.state.reportPermissionsArray.includes("btid_gap_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className=""  to={{
                                                                                    pathname: "/admin/btid-gap-report",
                                                                                    state: this.state.login_merchant
                                                                                  }}>
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Btid Gap Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> :null}

                                                {this.state.reportPermissionsArray.includes("enigmatic_smile_txn_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className=""  to={{
                                                                                    pathname: "/admin/enigmatic-smile-txn-report",
                                                                                    state: this.state.login_merchant
                                                                                  }}>
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Enigmatic Smile Txn Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> :null}
                                                {this.state.reportPermissionsArray.includes("e_rupee_txn_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className=""  to={{
                                                                                    pathname: "/admin/e-rupee-txn-report",
                                                                                    state: this.state.login_merchant
                                                                                  }}>
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Erupee Transaction Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> :null}
                                                {this.state.reportPermissionsArray.includes("reliance_utid_wise_billing_summary_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className="" to="/admin/reliance-utid-wise-billing-summary-report">
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Reliance Utid Wise Billing Summary Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                                {this.state.reportPermissionsArray.includes("reliance_bank_utid_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className="" to="/admin/reliance-bank-utid-report/">
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>Reliance Bank Utid Report</h5>
                                                                    {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                                {this.state.reportPermissionsArray.includes("hdfc_upi_txn_report") === true ?
                                                <div className="col-lg-3 col-xs-6">
                                                    <div className="card report-dash">
                                                        <div className="content text-center">
                                                            <Link className="" to="/admin/hdfc-upi-txn-report/">
                                                                <div className="report-thumbs-ico">
                                                                    <div className="icon-big text-center folder-icon">
                                                                        <i className="fa fa-folder-o"></i>
                                                                    </div>
                                                                    <h5>HDFC UPI Transaction Report</h5>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(TransactionReport);